import * as Sentry from '@sentry/react';
import type { ComponentType } from 'react';
import type { ErrorBoundaryProps, ErrorReporterUser, WebErrorReporter } from '../error-reporter';

/**
 * `WebErrorReporter` implementation backed by `@sentry/react`. Assumes
 * `Sentry.init(...)` has already been called (see `web/src/main.tsx`).
 */
export class SentryWebErrorReporter implements WebErrorReporter {
  readonly ErrorBoundary = Sentry.ErrorBoundary as unknown as ComponentType<ErrorBoundaryProps>;

  captureException(error: unknown): void {
    Sentry.captureException(error);
  }

  setUser(user: ErrorReporterUser | null): void {
    Sentry.setUser(user);
  }
}
